/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
// import { useBlockProps } from '@wordpress/block-editor';
import { useBlockProps	} from '@wordpress/block-editor';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faBookOpenReader } from '@fortawesome/free-solid-svg-icons';
/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save({attributes, props}) {

	const { 
        k2LdCoursefilterType, k2LdCoursedata, 
        K2ldItemBorderRadiusImageCG, K2ldItemWidthImageCG, K2ldItemHeightImageCG,
        K2ldItemtagBGcolorCG, K2ldItemtagSizeCG, K2ldTagFontFamCG, K2ldTagFontWeightCG, K2ldTagColorCG, K2ldTagAlignmentCG,K2ldTagWidthCG,
        K2ldTitleColorCG,K2ldItemTitleSizeCG, K2ldTitleFontFamCG, K2ldTitleFontWeightCG,
        K2ldContentColorCG,K2ldItemContentSizeCG, K2ldContentFontFamCG, K2ldContentFontWeightCG, K2ldItemContentLineHeightCG,
        K2ldLabelColorCG,K2ldItemLabelSizeCG, K2ldLabelFontFamCG, K2ldLabelFontWeightCG,K2ldLabelIconColorCG,
        K2ldButtonColorCG,K2ldItemButtonSizeCG, K2ldButtonFontFamCG, K2ldButtonFontWeightCG,
        K2ldProgressColorCG,K2ldItemProgressSizeCG, K2ldProgressFontFamCG, K2ldProgressFontWeightCG, K2ldProgressBgColorCG,
        K2ldItemPaddingCoursegrid, K2ldItemMarginCoursegrid, K2ldItemBorderCoursegrid, K2ldItemBorderRadiusCoursegrid, K2ldmainContBackgroundCoursegrid
     } = attributes;

     const ImageStyles = {
        borderTopLeftRadius: K2ldItemBorderRadiusImageCG.top,
		borderTopRightRadius: K2ldItemBorderRadiusImageCG.right,
		borderBottomRightRadius: K2ldItemBorderRadiusImageCG.bottom,
		borderBottomLeftRadius: K2ldItemBorderRadiusImageCG.left,
        width: K2ldItemWidthImageCG + "%",
        height: K2ldItemHeightImageCG +"px"
    }

    let tagStyles = {
        background: K2ldItemtagBGcolorCG,
        fontSize: K2ldItemtagSizeCG + "px",
        fontWeight: K2ldTagFontWeightCG,
        fontFamily: K2ldTagFontFamCG,
        color: K2ldTagColorCG,
        width: K2ldTagWidthCG+'%'
    }
    if(K2ldTagAlignmentCG === 'top left'){
        tagStyles.top="20px";
        tagStyles.left="20px";
        tagStyles.right="auto";
    }
    else if(K2ldTagAlignmentCG === 'top center'){
        tagStyles.top="20px";
        tagStyles.left="0";
        tagStyles.right="0";
        tagStyles.margin="0 auto";

    }
    else if(K2ldTagAlignmentCG === 'top right' ){
        tagStyles.top="20px";
        tagStyles.left="auto";
        tagStyles.right="20px";
    }
    else if(K2ldTagAlignmentCG === 'center left'){
        tagStyles.top="44%";
        tagStyles.left="20px";
        tagStyles.right="auto";
    }
    else if(K2ldTagAlignmentCG === 'center center'){
        tagStyles.top="40%";
        tagStyles.left="0";
        tagStyles.right="0";
        tagStyles.margin="0 auto";
    }
    else if(K2ldTagAlignmentCG === 'center right'){
        tagStyles.top="44%";
        tagStyles.left="auto";
        tagStyles.right="20px";
    }
    else if(K2ldTagAlignmentCG === 'bottom left' ){
        tagStyles.bottom="20px";
        tagStyles.left="20px";
        tagStyles.right="auto";
    }
    else if(K2ldTagAlignmentCG === 'bottom center'){
        tagStyles.bottom="20px";
        tagStyles.left="0";
        tagStyles.right="0";
        tagStyles.margin="0 auto";
    }
    else if( K2ldTagAlignmentCG === 'bottom right' ){
        tagStyles.bottom="20px";
        tagStyles.left="auto";
        tagStyles.right="20px";
    }
    else{
        null;
    }
    let TitleStyles = {
        fontSize: K2ldItemTitleSizeCG + "px",
        fontWeight: K2ldTitleFontWeightCG,
        fontFamily: K2ldTitleFontFamCG,
        color: K2ldTitleColorCG
    }

    let ContentStyles = {
        fontSize: K2ldItemContentSizeCG + "px",
        fontWeight: K2ldContentFontWeightCG,
        fontFamily: K2ldContentFontFamCG,
        color: K2ldContentColorCG,
        lineHeight: K2ldItemContentLineHeightCG+"rem"
    }

    let LabelStyles = {
        fontSize: K2ldItemLabelSizeCG + "px",
        fontWeight: K2ldLabelFontWeightCG,
        fontFamily: K2ldLabelFontFamCG,
        color: K2ldLabelColorCG
    }

    let LabeliconStyles = {
        color:K2ldLabelIconColorCG
    }

    let ButtonStyles = {
        fontSize: K2ldItemButtonSizeCG + "px",
        fontWeight: K2ldButtonFontWeightCG,
        fontFamily: K2ldButtonFontFamCG,
        color: K2ldButtonColorCG
    }

    let ProgressStyles = {
        fontSize: K2ldItemProgressSizeCG + "px",
        fontWeight: K2ldProgressFontWeightCG,
        fontFamily: K2ldProgressFontFamCG,
        color: K2ldProgressColorCG
    }

    const cardDescriptionStyles = {
        paddingTop: K2ldItemPaddingCoursegrid.top,
		paddingRight: K2ldItemPaddingCoursegrid.right,
		paddingBottom: K2ldItemPaddingCoursegrid.bottom,
		paddingLeft: K2ldItemPaddingCoursegrid.left,
        marginTop: K2ldItemMarginCoursegrid.top,
		marginRight: K2ldItemMarginCoursegrid.right,
		marginBottom: K2ldItemMarginCoursegrid.bottom,
		marginLeft: K2ldItemMarginCoursegrid.left,
        borderColor: K2ldItemBorderCoursegrid.color,
        borderStyle: K2ldItemBorderCoursegrid.style,
        borderWidth: K2ldItemBorderCoursegrid.width,
        borderTopLeftRadius: K2ldItemBorderRadiusCoursegrid.top,
		borderTopRightRadius: K2ldItemBorderRadiusCoursegrid.right,
		borderBottomRightRadius: K2ldItemBorderRadiusCoursegrid.bottom,
		borderBottomLeftRadius: K2ldItemBorderRadiusCoursegrid.left,
        background: K2ldmainContBackgroundCoursegrid
    }
	
	return (
		<div {...useBlockProps.save()}>
			<div className='k2_ld_course_grid_parent_container_save' data-courseFilterType={k2LdCoursefilterType}>
                {k2LdCoursedata.map((course, index) => (
                    <div key={index} className='k2_ld_course_grid_item' id={"course_grid_single_" + course.ID}>
                        <div className="k2_ld_course_image">
                            {course.image_url && <img src={course.image_url} alt={course.title} style={ImageStyles} />}
                            <div className="k2_ld_course_image_tag" style={tagStyles}>
                                {
                                    course.user_course_status != null ?
                                        course.user_course_status === 'not_started' ?
                                            'Not Started'
                                        :
                                        course.user_course_status === 'in_progress' ?
                                            'In Progress'
                                        :
                                        'Completed'
                                    :
                                    course.course_type === 'free' ?
                                    'Free'
                                    :
                                    course.course_type === 'paynow' ?
                                    'Buy Now'
                                    :
                                    'Open'
                                    
                                }
                                
                            </div>
                        </div>
                        <div className="k2_ld_course_description_cont" style={cardDescriptionStyles} >
                            <h5 style={TitleStyles}>{course.title}</h5>
                            <p className="course_excerpt" style={ContentStyles} >{course.course_des}</p>
                            <div className="k2_ld_lessons_container">
                                <div className="k2_ld_lessons_info">
                                <FontAwesomeIcon icon={faBookOpen} style={LabeliconStyles} />
                                    <p style={LabelStyles} >{course.number_of_lessons.length} Lessons</p>
                                </div>
                                <div className="k2_ld_student_info">
                                    <FontAwesomeIcon icon={faBookOpenReader} style={LabeliconStyles} />
                                    <p style={LabelStyles} >{course.number_of_students.length} Students</p>
                                </div>
                            </div>
                            <div className="k2_ld_course_button_container">
                                {course.completion_percentage != null ?
                                    <a style={ButtonStyles} href={course.permalink} >
                                        Get Started
                                    </a>
                                    :
                                    <a href={course.permalink} >
                                        {course.course_type === 'free' ?
                                            'Enroll Today'
                                        :
                                            course.course_type === 'paynow' ?
                                            'Buy Now'
                                        :
                                            'See more'
                                        }
                                    </a>
                                }
                               
                            </div>
                            {course.completion_percentage != null &&
                                <div>
                                    <div className="k2_course_progress_bar_container">
                                        <div class="k2_course_grid_progress_line" style={{width: course.completion_percentage +'%', backgroundColor: K2ldProgressBgColorCG}}></div>
                                    </div>
                                    <div class="k2_course_progress_text">
                                        <span style={ProgressStyles} >{course.completion_percentage +'%'} complete</span>
                                    </div>
                                </div>
                            }  
                           
                        </div>
                    </div>
                ))}
            </div>
		</div>
	);
}
